import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const dataImportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_REF_DATA_EVENTS_BY_RECON_SUCCESS:
            return {
                ...state,
                refDataEventsByGroup: action.payload,
            };
        case actionTypes.GET_CONNECTION_DETAILS:
            return {
                ...state,
                refDataConnectionDetails: action.payload,
            };
        case actionTypes.SET_DB_COLUMNS:
            return {
                ...state,
                dbImportColumns: action.payload,
            };
        case actionTypes.GET_SERVER_FOLDERS:
            return {
                ...state,
                serverFolderPaths: action.payload,
            };
        case actionTypes.GET_XSD_TEMPLATES:
            return {
                ...state,
                allXSDTemplates: action.payload,
            };
        case actionTypes.SET_AUTO_MAP:
            return {
                ...state,
                isAutoMap: action.payload,
            };
        default:
            return state;
    }
};

export default dataImportsReducer;
